import { UserException } from '@/domain/user/exception/UserException'

export class InvalidParametersException extends UserException {

}
